import { useEffect } from "react";
import ReactGA from "react-ga4";
import projectConfig from "config/projectConfig.js";

const GATracking = ({ currentProject }) => {
	useEffect(() => {
		const config = projectConfig[currentProject];
		if (config && config.gaMeasurementId) {
			ReactGA.initialize(config.gaMeasurementId);
		}

		return () => {
			ReactGA.reset();
		};
	}, [currentProject]);

	return null;
};

export default GATracking;
